import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import BlurOnIcon from '@mui/icons-material/BlurOn';

const Logo: React.FC = () => {
  const theme = useTheme();

  return (
    <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <BlurOnIcon 
          sx={{ 
            fontSize: 36, 
            color: theme.palette.primary.main,
            mr: 1,
            animation: 'pulse 2s infinite ease-in-out',
            '@keyframes pulse': {
              '0%': { opacity: 0.7 },
              '50%': { opacity: 1 },
              '100%': { opacity: 0.7 },
            }
          }} 
        />
        <Typography 
          variant="h5" 
          component="div" 
          sx={{ 
            fontWeight: 700,
            background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '0.5px'
          }}
        >
          Nexus NFT
        </Typography>
      </Box>
    </Link>
  );
};

export default Logo; 